const stateList = {};

function synchroObjectValues(targetObj, syncObj) {
    if (!targetObj || !syncObj) return;
    for (const item in targetObj) {
        if (item in syncObj) {
            if (typeof targetObj[item] === 'object') synchroObjectValues(targetObj[item], syncObj[item]);
            else targetObj[item] = syncObj[item];
        }
    }
}

function storeDataToModule(storeData, state) {
    try {
        const data = JSON.parse(storeData);
        synchroObjectValues(state, data);
    } catch (error) {
        console.error(error);
    }
}

function onMutation(mutation) {
    for (const key in stateList) {
        const stateModule = stateList[key];
        if (stateModule.mutations.includes(mutation.type))
            localStorage.setItem(key, JSON.stringify(stateModule.state));
    }
}

function setPersistState(storage, key, stateModule) {
    const storeData = localStorage.getItem(key)
    if (storeData) storeDataToModule(storeData, stateModule.state);

    stateList[key] = {
        state: stateModule.state,
        mutations: Object.keys(stateModule.mutations)
    }

    storage.subscribe(onMutation);
}

export default setPersistState;